import { render, staticRenderFns } from "./InviteUserCardForm.vue?vue&type=template&id=1b277e34&"
import script from "./InviteUserCardForm.vue?vue&type=script&lang=js&"
export * from "./InviteUserCardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports